import { Link } from "react-router-dom";

function Blogs() {
    const blogs = [
        {
            title: "Child Health – बच्चों की सेहत और सही विकास",
            desc: "बच्चों का शारीरिक और मानसिक विकास सही पोषण, टीकाकरण और देखभाल पर निर्भर करता है।",
            slug: "child-health",
            image: "/images/blogs/1.jpg",
        },
        {
            title: "Women Health – महिलाओं के स्वास्थ्य की पूरी जानकारी",
            desc: "महिलाओं के लिए हार्मोन संतुलन, एनीमिया से बचाव और नियमित जांच जरूरी है।",
            slug: "women-health",
            image: "/images/blogs/2.jpg",
        },
        {
            title: "Diabetes Care – मधुमेह को कैसे नियंत्रित करें",
            desc: "सही खानपान, नियमित जांच और दवाइयों से डायबिटीज को नियंत्रित किया जा सकता है।",
            slug: "diabetes-care",
            image: "/images/blogs/3.jpg",
        },
        {
            title: "Heart Health – दिल को स्वस्थ कैसे रखें",
            desc: "नियमित व्यायाम, तनाव कम करना और संतुलित आहार दिल को स्वस्थ रखता है।",
            slug: "heart-health",
            image: "/images/blogs/4.jpg",
        },
        {
            title: "Bone & Joint Care – हड्डियों और जोड़ों की देखभाल",
            desc: "कैल्शियम, विटामिन D और सही जीवनशैली से जोड़ों की समस्याओं से बचा जा सकता है।",
            slug: "bone-joint-care",
            image: "/images/blogs/5.jpg",
        },
        {
            title: "Pregnancy Care – गर्भावस्था में जरूरी सावधानियां",
            desc: "गर्भावस्था के दौरान पोषण, आराम और नियमित जांच माँ और बच्चे के लिए जरूरी है।",
            slug: "pregnancy-care",
            image: "/images/blogs/6.jpg",
        },
        {
            title: "Blood Pressure – हाई बीपी के लक्षण और इलाज",
            desc: "हाई ब्लड प्रेशर एक साइलेंट बीमारी है जिसे समय पर नियंत्रित किया जा सकता है।",
            slug: "blood-pressure",
            image: "/images/blogs/7.jpg",
        },
        {
            title: "Healthy Diet – संतुलित आहार क्यों जरूरी है",
            desc: "संतुलित आहार शरीर को ऊर्जा देता है और रोग प्रतिरोधक क्षमता बढ़ाता है।",
            slug: "healthy-diet",
            image: "/images/blogs/8.jpg",
        },
        {
            title: "Seasonal Diseases – मौसमी बीमारियों से बचाव",
            desc: "मौसम बदलने पर सर्दी, खांसी और बुखार से बचाव बहुत जरूरी है।",
            slug: "seasonal-diseases",
            image: "/images/blogs/9.jpg",
        },
        {
            title: "Emergency Care – आपातकाल में क्या करें",
            desc: "आपात स्थिति में सही समय पर सही कदम उठाना मरीज की जान बचा सकता है।",
            slug: "emergency-care",
            image: "/images/blogs/10.jpg",
        },
    ];

    return (
        <div className="py-16 px-4 bg-gradient-to-r from-blue-600 to-indigo-600">
            <h1 className="text-3xl md:text-4xl font-bold text-white text-center mb-14">
                स्वास्थ्य ब्लॉग / Health Blogs
            </h1>

            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {blogs.map((blog, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col"
                    >
                        {/* ✅ IMAGE FULL VISIBLE */}
                        <div className="w-full h-56 bg-gray-100 flex items-center justify-center">
                            <img
                                src={blog.image}
                                alt={blog.title}
                                className="w-full h-full object-contain"
                            />
                        </div>

                        {/* CONTENT */}
                        <div className="p-6 flex flex-col justify-between flex-1">
                            <div>
                                <h2 className="text-lg font-bold text-gray-900 mb-3">
                                    {blog.title}
                                </h2>

                                <p className="text-gray-700 text-sm leading-relaxed">
                                    {blog.desc}
                                </p>
                            </div>

                            <Link
                                to={`/blog/${blog.slug}`}
                                className="text-blue-700 font-semibold mt-4 inline-block"
                            >
                                पूरा पढ़ें →
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Blogs;
